import { useTranslation } from "react-i18next";
import loginImage from "@/assets/images/emtech_connection_image.svg";
import { LoginForm } from "@/components/LoginForm";
import { Logo } from "@/components/Logo";

export const Login = () => {
	const { t } = useTranslation();

	return (
		<div>
			<div className="mr-auto flex justify-between p-10 w-full h-[80px] items-center">
				<Logo imageWidth={100} />
			</div>
			<div className="min-h-screen m-0 -mt-20 grid grid-cols-12">
				<div className="bg-secondaryBg col-span-12 md:col-span-6  flex justify-center items-center">
					<div className="flex flex-col justify-center">
						<img
							className="flex-none max-w-[350px]"
							src={loginImage}
							alt={t("login.title")}
						/>
						<h2 className="text-[28px] font-bold text-center m-0 mt-5 text-white">
							<span className="text-[#279f70]">{t("digital.cash")}</span>
							<br />
							{t("like.never.before")}
						</h2>
					</div>
				</div>
				<div className="col-span-12 md:col-span-6 flex justify-center items-center bg-primaryBg">
					<div className="flex-1 flex flex-col justify-center max-w-[400px]">
						<h1 className="text-[36px] mb-[10px] text-textColor">
							{t("login.title")}
						</h1>
						<p className="text-[16px] mb-[36px] m-0 text-textAccentColor">
							Sign In to manage your account
						</p>
						<LoginForm />
					</div>
				</div>
			</div>
		</div>
	);
};
